var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3211 11.4283L7.96403 13.7853C6.99176 14.7576 5.40077 14.7576 4.4285 13.7853C3.45623 12.8131 3.45623 11.2221 4.4285 10.2498L6.78552 7.89279L5.60701 6.71428L3.24999 9.0713C1.62364 10.6976 1.62364 13.3375 3.24999 14.9639C4.87634 16.5902 7.5162 16.5902 9.14255 14.9639L11.4996 12.6068L10.3211 11.4283ZM9.1426 3.17869L6.78558 5.53571L7.96409 6.71422L10.3211 4.3572C11.2934 3.38493 12.8844 3.38493 13.8566 4.3572C14.8289 5.32947 14.8289 6.92046 13.8566 7.89273L11.4996 10.2498L12.6781 11.4283L15.0352 9.07124C16.6615 7.4449 16.6615 4.80503 15.0352 3.17869C13.4088 1.55234 10.7689 1.55234 9.1426 3.17869ZM10.9103 6.12504L6.19627 10.8391L7.37478 12.0176L12.0888 7.30355L10.9103 6.12504Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyLink);
export default __webpack_public_path__ + "static/media/copyLink.242fbfbb.svg";
export { ForwardRef as ReactComponent };